var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    { attrs: { title: "编辑", visible: true, "before-close": _vm.closeBox } },
    [
      _c(
        "el-form",
        [
          _c(
            "el-form-item",
            { attrs: { label: "物流名称" } },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "物流名称",
                  disabled: _vm.form.logistics_id != ""
                },
                model: {
                  value: _vm.form.logistics_name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "logistics_name", $$v)
                  },
                  expression: "form.logistics_name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "联系人" } },
            [
              _c("el-input", {
                attrs: { placeholder: "联系人" },
                model: {
                  value: _vm.form.contacts,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "contacts", $$v)
                  },
                  expression: "form.contacts"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "联系电话" } },
            [
              _c("el-input", {
                attrs: { placeholder: "联系电话" },
                model: {
                  value: _vm.form.contacts_phone,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "contacts_phone", $$v)
                  },
                  expression: "form.contacts_phone"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "状态:" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "状态" },
                  model: {
                    value: _vm.form.status,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status"
                  }
                },
                _vm._l(_vm.status_ops, function(item) {
                  return _c("el-option", {
                    key: item.key,
                    attrs: { label: item.name, value: item.key }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "备注说明" } },
            [
              _c("el-input", {
                attrs: { placeholder: "备注说明" },
                model: {
                  value: _vm.form.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "remark", $$v)
                  },
                  expression: "form.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.closeBox } }, [_vm._v("取 消")]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addLogistics } },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e19d17da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e19d17da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/logistics/components/edit.vue
// module id = null
// module chunks = 